import type { Priority } from "@app/core";
import { splitSeriesAt } from "./split-series.js";
import type { SeriesGet, SeriesSet } from "./types.js";

/** Fields that may differ per occurrence. undefined = inherit effective value at split point. */
export type SeriesEditPatch = {
  /** New dtstart for the split tail. undefined = keep the occurrence slot. */
  newDueAt?: string | undefined;
  title?: string | undefined;
  notes?: string | undefined;
  duration_minutes?: number | undefined;
  priority?: Priority | undefined;
  /** Real nullable field — null explicitly clears the colour. */
  custom_color?: string | null | undefined;
  all_day?: boolean | undefined;
  /** Topics for the tail segment. undefined = inherit the source's topics. */
  topic_ids?: string[] | undefined;
  /** Labels for the tail segment. undefined = inherit the source's labels. */
  label_ids?: string[] | undefined;
  /** New tz for the tail segment. undefined = inherit the source rule's tz. */
  tz?: string | null | undefined;
  /** Reshaped rrule string for the tail segment (cadence change applied "this
   *  and following"). undefined = keep the cadence in effect at the split point. */
  newRrule?: string | undefined;
};

export async function editSeriesFromOccurrence(
  set: SeriesSet,
  get: SeriesGet,
  sourceId: string,
  occurrenceIso: string,
  patch: SeriesEditPatch,
): Promise<void> {
  await splitSeriesAt(set, get, sourceId, occurrenceIso, patch);
}
